import { render, staticRenderFns } from "./ShelfAlbumItem.vue?vue&type=template&id=4df57d97&scoped=true&"
import script from "./ShelfAlbumItem.vue?vue&type=script&lang=js&"
export * from "./ShelfAlbumItem.vue?vue&type=script&lang=js&"
import style0 from "./ShelfAlbumItem.vue?vue&type=style&index=0&id=4df57d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df57d97",
  null
  
)

export default component.exports